// src/locales/en/ecomOrders.js (COMPLETE FILE with Order Lookup additions)
export const ecomOrders = {
  // Page titles and navigation
  createNewOrder: 'Create New Online Order',
  addNewOrderToSystem: 'Add a new e-commerce order to the system',
  backToOrders: 'Back to Orders',
  allOrders: 'All Online Orders',
  addOrder: 'Add Order',
  editOrder: 'Edit Online Order',
  deleteOrder: 'Delete Order',
  viewOrderDetails: 'View Order Details',
  
  // Form sections
  shopSelection: 'Shop Selection',
  customerInformation: 'Customer Information',
  orderItems: 'Order Items',
  orderStatusAndType: 'Order Status & Payment Type',
  paymentRecords: 'Payment Records',
  replacementOrders: 'Replacement Order Details',
  orderSummary: 'Order Summary',
  
  // Shop selection
  selectShop: 'Select Shop',
  selectShopRequired: 'Please select a shop',
  shopSelectionDesc: 'Choose the shop for this order',
  currentShop: 'Current Shop',
  changeShop: 'Change Shop',
  shopCannotBeChanged: 'Shop cannot be changed after order creation',
  
  // Customer information
  customerName: 'Customer Name',
  customerNameRequired: 'Customer name is required',
  customerNamePlaceholder: 'Enter customer full name',
  
  privateReference: 'Private Reference',
  privateReferencePlaceholder: 'Internal reference (optional)',
  
  address: 'Delivery Address',
  addressRequired: 'Delivery address is required',
  addressPlaceholder: 'Enter full delivery address',
  
  city: 'Delivery City',
  cityRequired: 'Please select delivery city',
  selectCity: 'Select delivery city',
  searchCity: "Search city...",
  
  phoneNumbers: 'Phone Numbers',
  phoneNumbersRequired: 'At least one phone number is required',
  phoneNumber: 'Phone Number',
  phoneNumberPlaceholder: 'Enter phone number',
  addPhoneNumber: 'Add Phone Number',
  removePhoneNumber: 'Remove Phone Number',
  primaryPhone: 'Primary',
  setPrimaryPhone: 'Set as primary',
  primaryPhoneRequired: 'Please set one phone number as primary',
  
  phoneLookupAutofilled: 'Details auto-filled from {{source}}',
  phoneLookupSourcePos: 'POS customer',
  phoneLookupSourceOrder: 'previous order',

  customerEmail: 'Customer Email',
  customerEmailPlaceholder: 'Enter customer email (optional)',
  invalidEmailFormat: 'Invalid email format',
  
  deliveryNotes: 'Delivery Notes',
  deliveryNotesPlaceholder: 'Special delivery instructions (optional)',
  
  specialNotes: 'Special Notes',
  specialNotesPlaceholder: 'Additional notes about the order (optional)',
  
  // Order items
  searchProducts: 'Search Products',
  searchProductsPlaceholder: 'Search by name, SKU, or barcode...',
  addProduct: 'Add Product',
  noProductsFound: 'No products found',
  productRequired: 'Please select a product',
  
  product: 'Product',
  quantity: 'Quantity',
  quantityRequired: 'Quantity is required',
  quantityMinimum: 'Quantity must be at least 1',
  
  unitPrice: 'Unit Price',
  unitPriceRequired: 'Unit price is required',
  unitPriceMinimum: 'Unit price must be greater than 0',
  
  lineDiscount: 'Line Discount',
  lineDiscountPlaceholder: 'Discount amount (optional)',
  lineDiscountMaximum: 'Discount cannot exceed line subtotal',
  
  lineTotal: 'Line Total',
  removeItem: 'Remove Item',
  
  atLeastOneItemRequired: 'At least one order item is required',
  
  // Product search results
  productResults: 'Product Results',
  selectProduct: 'Select Product',
  productSku: 'SKU',
  productStock: 'Stock',
  productPrice: 'Price',
  productAttributes: 'Attributes',
  
  // Order status and payment
  orderStatus: 'Order Status',
  orderStatusRequired: 'Please select order status',
  
  statusReason: 'Status Reason',
  statusReasonRequired: 'Status reason is required for this status',
  selectStatusReason: 'Select reason',
  
  holdUntilDate: 'Hold Until Date',
  holdUntilDateRequired: 'Hold date is required for this status',
  
  paymentType: 'Payment Type',
  paymentTypeRequired: 'Please select payment type',
  paymentTypeLockedHint: 'Payment type cannot be changed once a payment has been verified',
  editPaymentsAndShift: 'Payments & Shift',
  selectPaidPaymentTypeFirst: 'Select Fully Paid or Partially Paid to add payments',
  outstandingBalance: 'Outstanding Balance',
  confirmPayment: 'Confirm Payment',
  paymentRecordedSuccess: 'Payment recorded successfully',
  failedToRecordPayment: 'Failed to record payment',
  confirmDeletePaymentRecord: 'Delete this unverified payment record?',
  messageCenterShift: 'Message Center Shift',
  saveShift: 'Save Shift',
  shiftUpdatedSuccess: 'Shift updated successfully',
  paymentTypeUpdatedSuccess: 'Payment type updated successfully',
  paymentRecordsNotRequired: "Payment records are not required",
  paymentRecordsNotRequiredHint: "Payment records are only required for 'Fully Paid' or 'Partialy Paid' payment types.",
  
  // Replacement orders - UPDATED
  replacedOrderLookup: 'Original Order Number / Airwaybill',
  replacedOrderLookupPlaceholder: 'Enter order number or airwaybill number',
  replacedOrderLookupRequired: 'Original order number or airwaybill is required for replacement orders',
  orderNotFound: 'Order not found',
  lookingUpOrder: 'Looking up order...',
  orderFoundSuccessfully: 'Order found successfully',
  
  // Legacy fields (kept for backward compatibility)
  replacedOrderId: 'Original Order ID',
  replacedOrderIdRequired: 'Original order ID is required for replacement orders',
  replacedOrderIdPlaceholder: 'Enter original order number',
  
  replacementReason: 'Replacement Reason',
  replacementReasonRequired: 'Replacement reason is required',
  selectReplacementReason: 'Select replacement reason',

  returnAirwaybillNumber: 'Return Airwaybill Number',
  returnAirwaybillNumberPlaceholder: 'Enter the return parcel airwaybill number (optional)',
  itemsToReturn: 'Items to Return',
  item: 'Item',
  remainingReturnableQty: 'Remaining Returnable Qty',
  returnQuantity: 'Return Quantity',
  returnQuantityExceedsRemaining: 'Return quantity exceeds the remaining returnable quantity for one or more items',
  returnPackageOrder: 'Return Package Order',
  returnPackageOrderCreated: 'Return package order created',

  // Payment records
  paymentRecordsRequired: 'Payment records are required for this payment type',
  paymentRecordsOptional: 'Payment records are optional for this payment type',
  addPaymentRecord: 'Add Payment Record',
  removePaymentRecord: 'Remove Payment Record',
  verifiedPaymentRecord: 'Verified',
  paymentRecordChange: 'Payment Record',
  auditItemAdded: 'Item added',
  auditItemRemoved: 'Item removed',
  auditItemUpdated: 'Item updated',
  auditBundleTag: 'Bundle: {{name}}',
  
  paymentMethod: 'Payment Method',
  paymentMethodRequired: 'Payment method is required',
  selectPaymentMethod: 'Select payment method',
  
  paymentAmount: 'Payment Amount',
  paymentAmountRequired: 'Payment amount is required',
  paymentAmountMinimum: 'Payment amount must be greater than 0',
  
  paymentReference: 'Payment Reference',
  paymentReferencePlaceholder: 'Transaction reference, receipt number, etc.',
  
  paymentDate: 'Payment Date',
  paymentDateRequired: 'Payment date is required',
  
  totalPaid: 'Total Paid',
  paymentBalance: 'Balance',
  codToCollect: 'COD to Collect',
  overpaidAmount: 'Overpaid',
  
  // Order summary and calculations
  subtotal: 'Subtotal',
  totalDiscount: 'Total Discount',
  deliveryCharge: 'Delivery Charge',
  tax: 'Tax',
  grandTotal: 'Grand Total',
  
  // Delivery charges
  calculatingDeliveryCharge: 'Calculating delivery charge...',
  deliveryChargeCalculated: 'Delivery charge calculated',
  deliveryNotAvailable: 'Delivery not available to this location',
  deliveryChargeFailed: 'Failed to calculate delivery charge',
  
  // Form actions
  createOrder: 'Create Order',
  updateOrder: 'Update Order',
  saveOrder: 'Save Order',
  cancel: 'Cancel',
  
  // Success messages
  orderCreatedSuccess: 'Order "{{orderNumber}}" created successfully!',
  orderUpdatedSuccess: 'Order updated successfully',
  orderSavedSuccess: 'Order saved successfully',
  
  // Error messages
  failedToCreateOrder: 'Failed to create order. Please try again.',
  failedToUpdateOrder: 'Failed to update order. Please try again.',
  failedToLoadOrder: 'Failed to load order details.',
  failedToLoadReferenceData: 'Failed to load required data. Please refresh the page.',
  
  someFieldsRequired: 'Please fill in all required fields',
  invalidOrderData: 'Please check order data and try again',
  noChangesDetected: 'No changes detected',
  
  // Loading states
  loadingReferenceData: 'Loading reference data...',
  loadingOrder: 'Loading order...',
  savingOrder: 'Saving order...',
  calculatingTotals: 'Calculating totals...',
  
  // Validation messages
  required: 'Required',
  optional: 'Optional',
  invalidPhoneNumber: 'Invalid phone number format',
  duplicatePhoneNumber: 'Phone number already exists',
  
  // Permission errors
  insufficientPermissions: 'You don\'t have permission to perform this action',
  cannotChangeUnitPrice: 'You don\'t have permission to change unit prices',
  cannotGiveDiscount: 'You don\'t have permission to give discounts',
  cannotChangeDeliveryCharge: 'You don\'t have permission to change delivery charges',
  
  // Order number
  orderNumber: 'Order Number',
  orderNumberPreview: 'Order Number Preview',
  generatedOrderNumber: 'Generated Order Number',
  
  // Order list (for future reference)
  ordersList: 'Orders List',
  searchOrders: 'Search orders...',
  filterByStatus: 'Filter by Status',
  filterByPaymentType: 'Filter by Payment Type',
  filterByShop: 'Filter by Shop',
  filterByCity: 'Filter by City',
  
  noOrdersFound: 'No orders found',
  noOrdersYet: 'No orders yet',
  
  // Date formats and common terms
  today: 'Today',
  yesterday: 'Yesterday',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
  
  // Order statuses (these might come from API but good to have fallbacks)
  pending: 'Pending',
  confirmed: 'Confirmed',
  hold: 'Hold',
  notConfirmed: 'Not Confirmed',
  cancelled: 'Cancelled',
  inCourier: 'In Courier',
  settled: 'Settled',
  returned: 'Returned',
  
  // Payment types
  cashOnDelivery: 'Cash On Delivery',
  fullyPaid: 'Fully Paid',
  partiallyPaid: 'Partially Paid',
  replacement: 'Replacement',
  
  // Payment methods
  cash: 'Cash',
  bankTransfer: 'Bank Transfer',
  cheque: 'Cheque',
  cardPayment: 'Card Payment',
  
  // Common UI elements
  loading: 'Loading...',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  view: 'View',
  search: 'Search',
  filter: 'Filter',
  clear: 'Clear',
  reset: 'Reset',
  
  // Keyboard navigation helpers
  enterToSelect: 'Press Enter to select',
  escapeToClose: 'Press Escape to close',
  arrowKeysToNavigate: 'Use arrow keys to navigate',
  
  // Accessibility
  selectOption: 'Select option',
  selectedOption: 'Selected option',
  optionsAvailable: '{{count}} options available',
  noOptionsAvailable: 'No options available',

  // Bulk Order Creation
  bulkOrderCreate: 'Upload Leads',
  bulkOrderCreateDesc: 'Upload Excel file to create multiple orders at once',
  downloadTemplate: 'Download Template',
  uploadFile: 'Upload File',
  validateOrders: 'Validate Orders',
  submitOrders: 'Submit Orders',
  submitValidOrders: 'Submit {{count}} Valid Orders',
  retryValidation: 'Fix & Revalidate',
  clearAll: 'Clear All',
  
  // File Upload
  dragDropFile: 'Drag and drop your Excel file here',
  orClickToSelect: 'or click to select file',
  supportedFormats: 'Supported formats: .xlsx, .csv',
  fileUploaded: 'File uploaded successfully',
  fileName: 'File Name',
  rowCount: '{{count}} rows',
  removeFile: 'Remove File',
  
  // Data Preview
  dataPreview: 'Data Preview',
  showingRows: 'Showing {{count}} orders',
  validRows: '{{count}} Valid',
  invalidRows: '{{count}} Invalid',
  editRow: 'Edit Row',
  deleteRow: 'Delete Row',
  
  // Validation
  validating: 'Validating orders...',
  validationComplete: 'Validation Complete',
  validationErrors: 'Validation Errors',
  validOrder: 'Valid Order',
  invalidOrder: 'Invalid Order',
  validationDetails: 'Validation Details',
  
  // Submission
  submitting: 'Submitting orders...',
  submissionComplete: 'Submission Complete',
  ordersCreatedSuccessfully: '{{count}} orders created successfully',
  ordersFailed: '{{count}} orders failed',
  viewCreatedOrders: 'View Created Orders',
  createMoreOrders: 'Create More Orders',
  
  // Progress
  processingOrders: 'Processing orders...',
  validatingOrder: 'Validating order {{current}} of {{total}}',
  creatingOrder: 'Creating order {{current}} of {{total}}',
  
  // Errors
  noShopSelected: 'Please select a shop first',
  noFileUploaded: 'Please upload a file',
  invalidFileFormat: 'Invalid file format. Please upload .xlsx or .csv file',
  fileParsingError: 'Error parsing file. Please check the file format',
  noOrdersFound: 'No orders found in the file',
  validationFailed: 'Validation failed. Please fix the errors and try again',
  submissionFailed: 'Some orders failed to create. Please review the results',
  
  // Column Names (for reference)
  columnCustomerName: 'Customer Name',
  columnCustomerEmail: 'Customer Email',
  columnAddress: 'Address',
  columnPhone1: 'Phone 1',
  columnPhone2: 'Phone 2',
  columnCityName: 'City Name',
  columnPaymentType: 'Payment Type',
  columnOrderStatus: 'Order Status',
  columnPrivateReference: 'Private Reference',
  columnDeliveryNotes: 'Delivery Notes',
  columnSpecialNotes: 'Special Notes',
  columnItemSku: 'Item {{number}} SKU',
  columnItemQuantity: 'Item {{number}} Quantity',
  columnItemCustomLineTotal: 'Item {{number}} Custom Line Total',
  columnDeliveryCharge: 'Delivery Charge',
  columnTotalDiscount: 'Total Discount',
  
  // Validation Error Messages
  customerNameRequired: 'Customer name is required',
  addressRequired: 'Address is required',
  cityNameRequired: 'City name is required',
  phoneNumberRequired: 'At least one phone number is required',
  privateReferenceRequired: 'Private reference is required',
  itemsRequired: 'At least one item is required',
  cityNotFound: 'City "{{city}}" not found',
  skuNotFound: 'SKU "{{sku}}" not found',
  skuNotAvailable: 'SKU "{{sku}}" is not available in this shop',
  invalidQuantity: 'Invalid quantity for item {{number}}',
  invalidPaymentType: 'Invalid payment type',
  invalidOrderStatus: 'Invalid order status',
  duplicateReference: 'Duplicate private reference',
  deliveryChargeNotConfigured: 'Delivery charge not configured for this city',
  
  // Table Headers
  row: 'Row',
  status: 'Status',
  customer: 'Customer',
  items: 'Items',
  total: 'Total',
  errors: 'Errors',
  actions: 'Actions',

  // Order list page
  totalOrders: 'Total Orders',
  allShops: 'All Shops',
  allCities: 'All Cities',
  allStatuses: 'All Statuses',
  allPaymentTypes: 'All Payment Types',
  fromDate: 'From Date',
  toDate: 'To Date',
  viewManageOrders: 'View and manage all e-commerce orders',
  searchOrdersPlaceholder: 'Search by order number, airwaybill number, customer name, phone, or private reference... (paste multiple values)',
  loadingOrders: 'Please wait while we load the orders...',
  unableToLoadOrders: 'Unable to Load Orders',
  noOrdersFoundDescription: 'No orders match your search criteria',
  startCreatingOrders: 'Start by creating your first order',
  courier: 'Courier',
  shop: 'Shop',
  products: 'Products',
  printAirwaybills: 'Print Airwaybills',
  orderSelected: 'order selected',
  ordersSelected: 'orders selected',

  // Order details modal
  orderDetails: 'Order Details',
  shopName: 'Shop Name',
  courierInformation: 'Courier Information',
  airwaybillNumber: 'Airwaybill Number',
  courierName: 'Courier Name',
  courierStatus: 'Courier Status',
  additionalInformation: 'Additional Information',
  updatedAt: 'Updated At',
  createdAt: 'Created At',
  createdBy: 'Created By',
  confirmedBy: 'Confirmed By',
  confirmedAt: 'Confirmed At',
  
  // Order Details Page (NEW)
  currentStatus: 'Current Status',
  trackingDetails: 'Tracking Details',
  packageTimeline: 'Package Timeline',
  codValue: 'COD Value',
  totalCourierFees: 'Total Courier Fees',
  courierStatusUpdatedAt: 'Courier Status Updated At',
  paidAmount: 'Paid Amount',
  codAmount: 'COD Amount',
  dispatchedDate: 'Dispatched Date',
  shiftDate: 'Shift Date',
  shiftType: 'Shift Type',
  allShiftTypes: 'All shift types',

  // Audit History (NEW)
  auditHistory: 'Audit History',
  totalChanges: 'Total Changes',
  lastModified: 'Last Modified',
  modifiedBy: 'Modified By',
  noAuditHistory: 'No modification history available',
  failedToLoadAuditHistory: 'Failed to load audit history',
  
  // Courier Tracking (NEW)
  failedToLoadCourierTracking: 'Failed to load courier tracking information',
  loadingTracking: 'Loading tracking information...',
  noTrackingEvents: 'No tracking events yet',
  latest: 'Latest',
  viewPackageTimeline: 'View package timeline',

  // Actions (NEW)
  show: 'Show',
  hide: 'Hide',
  
  // Call Attempts (NEW)
  callAttempts: 'Call Attempts',

  // Related Documents
  relatedDocuments: 'Related Documents',
  packingBatches: 'Packing Batches',
  returnBatches: 'Return Batches',
  courierInvoices: 'Courier Invoices',
  failedToLoadRelations: 'Failed to load related documents',

  // Filter labels
  allBusinessCouriers: 'All Business Couriers',
  businessCourier: 'Business Courier',
  allCourierStatuses: 'All Courier Statuses',

  // Permission errors
  noPermissionEditDispatchedOrders: 'You don\'t have permission to edit dispatched orders',
  noPermissionEditInPackingOrders: 'You don\'t have permission to edit in-packing orders',

  // Weight
  weight: 'Weight',
  weightKg: 'Weight (kg)',

  // Order Origin
  orderOrigin: 'Order Origin',
  paid: 'Paid',
  organic: 'Organic',
  viewShift: 'View shift',

  // Export
  exportConfirmTitle: 'Export Orders',
  exportConfirmMessage: 'Export {{count}} orders matching the current filters to CSV?',
  exportCapNote: 'Only the first {{max}} orders will be exported.',
  exportingOrders: 'Exporting Orders',
  noOrdersToExport: 'No orders to export with the current filters.',
  exportAlreadyRunning: 'An export is already running. Cancel it or wait for it to finish.',
  exportCompleteBackground: 'Export complete. Your file has been downloaded.',

  // Shop change
  shopChangeTitle: 'Change Shop',
  shopChangeClearsItems: 'Changing the shop will clear the selected order items. Continue?',

  // Payment Proof
  paymentProof: 'Payment Proof',
  uploadProof: 'Upload proof',
  changeProof: 'Change',
  viewProofPdf: 'View uploaded PDF',
  invalidProofFormat: 'Only .jpg, .png or .pdf files are allowed',
  proofTooLarge: 'File must be under 5MB',
  proofUploadFailed: 'Upload failed, please try again',

  // Cross Sell
  crossSellItem: 'Cross Sell',
  bundle: 'Bundle',
  bundleQuantity: 'Bundle Qty',
  bundleComponents: 'Bundle Components',
  bundleTotal: 'Bundle Total',
  free: 'FREE',
  removeBundle: 'Remove bundle',
  crossSellBundles: 'Cross Sell (bundles)',
  crossSellQuantity: 'Cross sold qty',

  // Message Center Shift
  selectDate: 'Select date',
  selectShift: 'Select shift',
  noShiftsForDate: 'No shifts for date',
  rememberShift: 'Remember',
  rememberShiftHint: 'Remember this shift so it loads automatically next time',

  // Payment records section
  paymentRecordNumber: "Payment Record #{number}",
  paymentSummary: "Payment Summary",
  orderTotal: "Order Total",
  paymentOverpaid: "Overpaid",
  paymentFullyPaid: "Fully Paid",
  paymentPending: "Payment Pending",
  noRemainingBalance: "No remaining balance to add a payment record",
  orderFieldSettings: "Field Settings",
  orderFieldSettingsDescription: "Choose which order fields are required when creating or editing an order.",
  enableFieldRequirements: "Customize required fields",
  enableFieldRequirementsHelp: "When off, all of these fields are optional",
  fieldRequired: "Required",
  fieldOptional: "Optional",
  orderFieldSettingsSaved: "Order field settings saved",
  orderFieldSettingsSaveFailed: "Failed to save order field settings",
  privateReferencePlaceholderRequired: "Internal reference",
  customerEmailPlaceholderRequired: "Enter customer email",
  deliveryNotesPlaceholderRequired: "Special delivery instructions",
  specialNotesPlaceholderRequired: "Additional notes about the order",
  clientRemarks: "Client Remarks",
  validation: {
    shopRequired: "Shop selection is required",
    customerNameRequired: "Customer name is required",
    addressRequired: "Delivery address is required",
    cityRequired: "Delivery city is required",
    phoneRequired: "At least one phone number is required",
    primaryPhoneRequired: "Please set one phone number as primary",
    privateReferenceRequired: "Private reference is required",
    customerEmailRequired: "Customer email is required",
    deliveryNotesRequired: "Delivery notes are required",
    specialNotesRequired: "Special notes are required",
    orderOriginRequired: "Order origin is required",
    invalidEmail: "Invalid email format",
    orderItemsRequired: "At least one order item is required",
    quantityInvalid: "Quantity must be greater than 0",
    unitPriceInvalid: "Unit price must be greater than 0",
    discountNegative: "Discount cannot be negative",
    discountExceedsLine: "Discount cannot exceed the line value",
    deliveryChargeNegative: "Delivery charge cannot be negative",
    duplicatePhone: "This phone number is already added",
    orderStatusRequired: "Order status is required",
    paymentTypeRequired: "Payment type is required",
    statusReasonRequired: "Status reason is required for this status",
    holdDateRequired: "Hold date is required for this status",
    replacedOrderRequired: "Original order number or airwaybill is required for replacement orders",
    orderLookupPending: "Please wait while we lookup the order",
    validReplacedOrderRequired: "Valid order number or airwaybill is required",
    replacementReasonRequired: "Replacement reason is required",
    replacementCodRequired: "COD amount is required for replacement orders",
    replacementCodNegative: "COD amount must be 0 or greater",
    replacementCodExceeds: "COD amount cannot exceed grand total",
    returnQtyExceeds: "Return quantity exceeds the remaining returnable quantity for one or more items",
    paymentRecordsRequired: "Payment records are required for this payment type",
    paymentMethodRequired: "Payment method is required",
    paymentAmountInvalid: "Payment amount must be greater than 0",
    paymentDateRequired: "Payment date is required",
    fullyPaidIncomplete: "Payment is incomplete. Total paid ({{totalPaid}}) must equal the grand total ({{grandTotal}}) for Fully Paid orders.",
    fullyPaidOverpaid: "Order is overpaid. Total paid ({{totalPaid}}) must equal the grand total ({{grandTotal}}) for Fully Paid orders.",
    partiallyPaidInvalid: "For Partially Paid orders, total paid ({{totalPaid}}) must be less than the grand total ({{grandTotal}}).",
  },
};